import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { InputHTMLAttributes } from 'react';
type RadioButtonProps = InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  onChange?: any;
  className?: string;
};
export default function RadioButton(t0) {
  const $ = _c(12);
  let className;
  let onChange;
  let props;
  if ($[0] !== t0) {
    ({
      onChange,
      className,
      ...props
    } = t0);
    if ("hasError" in props) {
      delete props.hasError;
    }
    $[0] = t0;
    $[1] = className;
    $[2] = onChange;
    $[3] = props;
  } else {
    className = $[1];
    onChange = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== onChange) {
    t1 = () => onChange?.();
    $[4] = onChange;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== className) {
    t2 = cx("h-4 w-4 cursor-pointer border-gray-300 text-secondary accent-secondary focus:border-[5px] checked:focus:border-[5px]", "checked:border-secondary checked:ring-transparent focus:border-secondary focus:ring-transparent", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <input {...props} type="radio" onChange={t1} className={t2} />;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}